<template>
  <div class="index">
    <div class="index-top">
      <div>青浦文旅码上游</div>
      <div class="chart" v-if="show" @click="$router.push('/chart')">大数据</div>
    </div>
    <div class="index-con">
      <div
        class="nav-item"
        v-for="(item, index) in navList"
        :key="index"
        @click="goApp(item)"
      >
        <img :src="item.icon" alt="" />
        <div>{{ item.nameDesc }}</div>
      </div>
      <p>欢迎关注青浦文旅！</p>
      <p>
        出游期间请按要求做好门票，同时请关注出行安全，践行文明旅游。
      </p>
      <p>
        我们将及时为您推送大客流预警和出游建议，持续为您提供最新最全的青浦文旅资讯和优惠信息。
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return { show: false, navList: "" };
  },
  created() {
    this.$axios.get("/getInfo").then((res) => {
      if (res.roles) {
        if (res.roles.indexOf("travel_admin") != -1) {
          this.show = true;
        } else {
          this.show = false;
        }
      }
    });
    this.$axios.get("/book/selectTravelModule").then((res) => {
      this.navList = res.data;
    });
  },
  methods: {
    goApp(item) {
      if (item.type == 1) {
        this.$router.push("/?moduleId=" + item.id);
      }
      if (item.type == 2) {
        this.$router.push("/hotel");
      }
    },
  },
};
</script>
<style scoped lang="less">
.index {
  width: 100%;
  height: 100%;
  background-color: #f4f4f4;
  position: relative;
  .index-top {
    background-image: linear-gradient(to right bottom, #2af598, #009efd);
    height: 1.8rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 0.22rem;
    letter-spacing: 0.02rem;
    font-weight: 600;
    .chart {
      background-color: #4dd9df;
      color: #fff;
      width: 0.9rem;
      line-height: 0.32rem;
      text-align: center;
      border-radius: 0.2rem;
      position: absolute;
      right: 0.2rem;
      top: 0.25rem;
      font-weight: 600;
      letter-spacing: 0.02rem;
      font-size: 0.15rem;
    }
  }
  .index-con {
    padding: 0.2rem;
    box-sizing: border-box;
    position: relative;
    top: -0.7rem;
    width: 100%;
    .nav-item {
      width: 100%;
      height: 0.75rem;
      padding: 0.2rem;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      background-color: #fff;
      border-radius: 0.1rem;
      margin-bottom: 0.15rem;
      img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.3rem;
      }
      div {
        letter-spacing: 0.03rem;
        font-size: 0.17rem;
      }
    }
  }
  p {
    font-size: 0.12rem;
    color: #030303;
    line-height: 0.15rem;
    margin-top: 0.1rem;
    text-align: justify;
  }
}
</style>
